import HealthcareSalarySearch from '../healthcare_salary_search';
import initNavToggles from '../nav_toggle';
import JobListingsApp from './JobListingsApp';

document.addEventListener('DOMContentLoaded', () => {
  initNavToggles();

  const node = document.getElementById('job-listings-app');
  if (node) {
    JobListingsApp();
  }

  // Initialize healthcare salary search if present
  const salarySearchForm = document.querySelector(
    '.healthcare-technician-salary-search-section'
  );
  if (salarySearchForm) {
    HealthcareSalarySearch.init();
  }
});
